
import React, { useState, useEffect } from 'react';
import { AccountingHeader } from '@/components/accounting/AccountingHeader';
import { AccountingTabs } from '@/components/accounting/AccountingTabs';
import ChartOfAccounts from '@/components/accounting/ChartOfAccounts';

const Accounting = () => {
  return (
    <div className="space-y-6">
      <AccountingHeader />
      <ChartOfAccounts />
      <AccountingTabs />
    </div>
  );
};

export default Accounting;
